import type { FooterAction } from './Footer';

export interface MobileFooterProps {
  totalLabel?: string;
  totalValue?: string;
  primary: FooterAction;
}

/** Sticky mobile bottom bar: running total + primary CTA (≥44px touch target). */
export function MobileFooter({ totalLabel, totalValue, primary }: MobileFooterProps) {
  return (
    <footer className="mfootbar">
      {totalValue != null && (
        <div className="mfootbar__total">
          {totalLabel && <div className="mfootbar__total-label">{totalLabel}</div>}
          <div className="mfootbar__total-value">{totalValue}</div>
        </div>
      )}
      <button
        type="button"
        className={`btn ${primary.gold ? 'btn--gold' : 'btn--primary'} mfootbar__cta`}
        onClick={primary.onClick}
        disabled={primary.disabled}
      >
        {primary.label}
        {primary.alert && (
          <span className="footbar__alert" role="img" aria-label="Some prints need your attention">
            !
          </span>
        )}
      </button>
    </footer>
  );
}
